import { BsBasket2, BsTags } from 'react-icons/bs'
import { FaTruckLoading } from 'react-icons/fa'
import { FiCheck, FiList } from 'react-icons/fi'
import { IoAnalyticsOutline } from 'react-icons/io5'
import { MdOutlineTimeline } from 'react-icons/md'

import type { ILink } from '@base/@types/components/Layout/Navigator'

const mrpLinks: ILink = {
  group: 'MRP',
  icon: <IoAnalyticsOutline />,
  roles: [
    'Diretor',
    'AnalistaCompra',
    'AnalistaDistribuicao',
    'Parceiro',
    'Administrador',
    'AnalistaPlanejamento',
    'GerenteProduto',

    'AnalistaComercial',
    'AnalistaCompra',
    'Analista',
    'Assistente'
  ],
  menu: [
    {
      name: 'Compra',
      path: '/mrp/compra',
      icon: <BsBasket2 />,
      description: 'Previsão de demanda e compras de produtos',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',

        'Analista',
        'Assistente'
      ]
    },
    {
      name: 'Compra',
      path: '/mrp/compra/programada',
      icon: <BsBasket2 />,
      description: 'Previsão programada de demanda e compras de produtos',
      badge: {
        label: 'Programada',
        color: 'green.600'
      },
      roles: [
        'Diretor',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'AnalistaCompra',

        'Analista',
        'Assistente'
      ]
    },
    {
      name: 'Distribuição',
      path: '/mrp/distribuicao',
      icon: <MdOutlineTimeline />,
      description: 'Distribuição de produtos para as lojas',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',

        'Analista',
        'Assistente'
      ]
    },
    {
      name: 'Oportunidade',
      path: '/mrp/oportunidade',
      icon: <BsTags />,
      description: 'Simulador de desconto para compras por oportunidade',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento',
        'GerenteProduto',
        'AnalistaComercial',
        'Analista',
        'Assistente'
      ]
    },
    {
      name: 'Reab. Emergencial',
      path: '/mrp/reabastecimento-emergencial',
      icon: <FaTruckLoading />,
      description: 'Distribuição emergencial de produtos para as lojas',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'AnalistaDistribuicao',
        'Parceiro',
        'Analista',
        'Administrador',
        'AnalistaPlanejamento',
        'Assistente'
      ]
    },
    {
      name: 'Aprovação (MRP)',
      path: '/mrp/aprovacao',
      icon: <FiCheck />,
      description: 'Aprovação de pedidos MRP pendentes',
      roles: [
        'Diretor',
        'AnalistaCompra',
        'Parceiro',
        'Administrador',
        'AnalistaPlanejamento'
      ]
    },
    {
      name: 'Pedidos / SKUs',
      path: '/mrp/pedidos-cronograma',
      icon: <FiList />,
      description: 'Visualização de pedidos e SKUs do cronograma de compras',
      roles: ['Administrador', 'AnalistaPlanejamento', 'AnalistaCompra']
    }
  ]
}

export default mrpLinks
